module.exports = __webpack_public_path__ + "static/media/mapa-nuevo-xs.2c1b6981.svg";